import { render, staticRenderFns } from "./UploadRecording.vue?vue&type=template&id=69c2fc29"
import script from "./UploadRecording.vue?vue&type=script&lang=js"
export * from "./UploadRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports